export default "__VITE_ASSET__fc46ef87__"